export default "__VITE_ASSET__2f1ec093__"